import { TIME_UNIT, safeDiv } from 'emma-common-ts';

export interface TimeUnit {
  value: TIME_UNIT;
  label: string;
  min: number;
  max: number;
  factor: number;
}

export const timeUnits: Array<TimeUnit> = [
  {
    value: TIME_UNIT.SECONDS,
    label: TIME_UNIT.SECONDS,
    min: 1,
    max: 120,
    factor: 1,
  },
  {
    value: TIME_UNIT.MINUTES,
    label: TIME_UNIT.MINUTES,
    min: 1,
    max: 120,
    factor: 60,
  },
  {
    value: TIME_UNIT.HOURS,
    label: TIME_UNIT.HOURS,
    min: 1,
    max: 48,
    factor: 60 * 60,
  },
  {
    value: TIME_UNIT.DAYS,
    label: TIME_UNIT.DAYS,
    min: 1,
    max: 90,
    factor: 60 * 60 * 24,
  },
  {
    value: TIME_UNIT.WEEKS,
    label: TIME_UNIT.WEEKS,
    min: 1,
    max: 18,
    factor: 60 * 60 * 24 * 7,
  },
  {
    value: TIME_UNIT.MONTHS,
    label: TIME_UNIT.MONTHS,
    min: 1,
    max: 6,
    factor: 60 * 60 * 24 * 30,
  },
  {
    value: TIME_UNIT.YEARS,
    label: TIME_UNIT.YEARS,
    min: 1,
    max: 99,
    factor: 60 * 60 * 24 * 365,
  },
];

export function getBestUnit(value: number, units: Array<TimeUnit>): TimeUnit | undefined {
  const minUnit = units[0];
  if (!value) {
    return minUnit;
  }
  const _units = units.slice(0);
  _units.reverse();
  const unit = _units.find((u) => {
    return safeDiv(value, u.factor) % 1 === 0;
  });
  return unit || minUnit;
}
